import React, {CSSProperties} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlusCircle} from '@fortawesome/pro-duotone-svg-icons/faPlusCircle';
import './QuestionIconCorrectNotSelected.scss';

export const QuestionCheckCorrectNotSelected = () => {
  // Hackish solution for now https://github.com/FortAwesome/react-fontawesome/issues/259
  const duotoneIconStyle: CSSProperties = {
    '--fa-primary-color': 'white',
    '--fa-secondary-opacity': 1,
  } as CSSProperties;

  return (
    <FontAwesomeIcon
      icon={faPlusCircle}
      style={duotoneIconStyle}
      className="question-icon-correct-not-selected"
      size="lg"
    />
  );
};
